import template from './employee_disciplinary_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeDisciplinaryReportViewModel
{
    constructor(page)
    {
        this.page = page;
        this.employee_missing_data = ko.observableArray();
        this.show_export_table = ko.observable(false);
        this.include_default = ko.observable(true),
        this.show_correct_values = ko.observable(true),
        this.current_department_id = ko.observable();
        this.selected_department = ko.observable();
        this.field_names = ko.observableArray();
        this.selected_field_name = ko.observable(null);
        this.selected_field_names = ko.observableArray([]);

        this.selected_department.subscribe((newValue) => {
            if (newValue != null) {
                this.current_department_id(newValue.department_id);
                this.page.updateData();
            }
            else {
                this.current_department_id(null);
                this.page.updateData();
            }
        });

        this.selected_field_names.subscribe(() => {
            this.page.updateData();
        });

        this.selected_disciplinary_options = ko.observableArray([]);
        this.selected_status_options = ko.observableArray([]);

        this.disciplinary_options = ko.observableArray([
            { field_name: "Written Warning #1" },
            { field_name: "Written Warning #2" },
            { field_name: "Invite to Disciplinary" },
            { field_name: "Letter of Dismissal" },
            { field_name: "Disciplinary Outcome" }
        ]);
        
        // For status dropdown
        this.status_options = ko.observableArray([
            { field_name: "Approved" },
            { field_name: "Completed" },
            { field_name: "In progress" },
            { field_name: "Expired" }
        ]);

        this.selected_options_text_disciplinary = ko.computed(() => {
            let selected_names = this.selected_disciplinary_options();
            if (!Array.isArray(selected_names)) selected_names = ko.unwrap(selected_names);
            if (selected_names.length === 0) return 'Filter by disciplinary';
            if (selected_names.length > 3) return `${selected_names.length} Disciplinary options selected`;
            return selected_names.join(', ');
        });
        
        this.selected_options_text_status = ko.computed(() => {
            let selected_names = this.selected_status_options();
            if (!Array.isArray(selected_names)) selected_names = ko.unwrap(selected_names);
            if (selected_names.length === 0) return 'Filter by status';
            if (selected_names.length > 3) return `${selected_names.length} Statuses selected`;
            return selected_names.join(', ');
        });

    }

    toggle_disciplinary_selection(field_name) {
        if (this.selected_disciplinary_options().includes(field_name))
            this.selected_disciplinary_options.remove(field_name);
        else
            this.selected_disciplinary_options.push(field_name);
    }

    toggle_status_selection(field_name) {
        if (this.selected_status_options().includes(field_name))
            this.selected_status_options.remove(field_name);
        else
            this.selected_status_options.push(field_name);
    }

    show_report_help() {
        Grape.dialog.open('SkillsCompetencyDataHelp', { employee_id: this.page.bindings.id });
    }

    async download_click() {
        let csv_string = '';
        const tables = document.querySelectorAll('#skills_matrix_report');

        tables.forEach((table, index) => {
            const rows = table.querySelectorAll('tr');

            // Add employee name as a header
            if (rows.length > 0) {
                let employee_name = rows[0].textContent.trim();
                csv_string += `${employee_name}\n\n`;
            }

            // Add column headers
            csv_string += 'Field name,Value,Valid till\n';

            // Start from second row to skip the employee name row and the header row
            for (let i = 2; i < rows.length; i++) {
                let cells = rows[i].querySelectorAll('td');
                if (cells.length >= 2) {
                    let field_name = cells[0].textContent.trim();
                    let value = cells[1].textContent.trim();
                    let valid_till = cells.length > 2 ? cells[2].textContent.trim() : '';
                    csv_string += `${field_name},${value},${valid_till}\n`;
                }
            }

            // Add a blank line between employees if there are more tables
            if (index < tables.length - 1)
                csv_string += '\n';
        });

        if (csv_string === '') {
            Grape.alerts.alert({ type: 'info', message: tr('No data to download') });
            console.log('No data to download');
            return;
        }

        let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
        let link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'skills_matrix_data_report.csv');

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

class EmployeeDisciplinaryReportPage
{
    constructor(bindings)
    {
        this.bindings = bindings;
        this.viewModel = new EmployeeDisciplinaryReportViewModel(this);
    }

    async init()
    {
        // check access to page
        if (await Utils.redirectOnAccessDenied('OutstandingDataReport'))
            return;

        document.title = tr('Warnings and disciplinary report');
        window.current_page_title(tr('Warnings and disciplinary report'));
    }

    async updateData() {
        let data = {
            department_id: this.viewModel.current_department_id()
        };
        if (this.viewModel.current_department_id() != null) {
            let res = await Grape.fetches.postJSON('/reports/fields_skills_matrix_report', data);
            if (res)
                this.viewModel.field_names(res);

            this.updateReportData();
        }
    }

    async updateReportData() {
        let data = {
            department_id: this.viewModel.current_department_id(),
            field_names: this.viewModel.selected_field_names()
        };

        let res = await Grape.fetches.postJSON('/reports/disciplinary_report', data);
        if (res) {
            if (this.viewModel.selected_field_names().length > 0) {
                let filtered_data = {
                    e_missing_info: res.e_missing_info.map(employee => {
                        return {
                            ...employee,
                            missing_items: employee.missing_items.filter(item =>
                                this.viewModel.selected_field_names().includes(item.field_name)
                            )
                        };
                    }),
                    field_names_list: res.field_names_list,
                    status: res.status
                };
                this.viewModel.employee_missing_data(ko.mapping.fromJS(filtered_data));
            }
            else
                this.viewModel.employee_missing_data(ko.mapping.fromJS(res));
        }
    }
}

export default {
    route: '[/]report/disciplinary',
    page_class: EmployeeDisciplinaryReportPage,
    template: template,
    template_filename: 'translation/disciplinary_report'
};
